import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { EntityInfo, LogStatus } from '@memberjunction/core';
import { SkipChatComponent } from '@memberjunction/ng-skip-chat';
import { SharedService } from '../../core/services/shared-service';
import { Router } from '@angular/router';
import { InstanceProviderService } from '../instance-provider.service';
import { MJEventType, MJGlobal, SafeJSONParse } from '@memberjunction/global';
import { buildRoutePrefix } from 'src/app/core/util';
import { GraphQLDataProvider } from '@memberjunction/graphql-dataprovider';

@Component({
  selector: 'app-skip',
  templateUrl: './skip.component.html',
  styleUrl: './skip.component.css'
})
export class SkipComponent implements AfterViewInit {
  constructor(
    public auth: AuthService, 
    private router: Router, 
    private location: Location,
    private sharedService: SharedService,
    private instanceProvider: InstanceProviderService,
    private cdr: ChangeDetectorRef
  ) {}

  @ViewChild('skipChat') skipChat!: SkipChatComponent;
  @ViewChild('skipChat', { read: ElementRef }) skipElement!: ElementRef;
 
  public targetEntities: EntityInfo[] = [];
  public loading: boolean = true;
  public loadingFailed: boolean = false;

  public async ngAfterViewInit() { 
    this.instanceProvider.isInstanceLoaded$.subscribe(async (status: 'loading' | 'loaded' | 'failed') => {
      if (status === 'loaded') {
        try {
          const p = this.instanceProvider.InstanceProvider;
          if (p) {
            this.skipChat.Provider = p;

            (p as GraphQLDataProvider).PushStatusUpdates().subscribe((status: any) => {
              if (status && status.message) {
                const innerObj = <any><unknown>SafeJSONParse(status.message);
                if (innerObj && innerObj.type === 'AskSkip') {
                  LogStatus(innerObj.message);
                  console.log(innerObj);
                }
              }
            });

            try {
              await this.skipChat.Load(true); // force refresh
              this.loading = false; // change this flag only after we have completed loading the chat
              this.loadingFailed = false;
            }
            catch (e) {
              this.sharedService.DisplayNotification('Error loading provider to instance', 'error', 2500);
            }
          }
          else {
            this.sharedService.DisplayNotification('Error loading provider to instance', 'error', 2500);
          } 
        } catch (error) {
          // Handle any unexpected errors
          this.sharedService.DisplayNotification(
            'Unexpected error occurred while loading the provider',
            'error',
            2500
          );
          console.error('Error:', error);
          this.loading = false;
          this.loadingFailed = true;
        } finally {
          // If needed, trigger change detection at the end of all operations
          this.cdr.detectChanges();
        }
      }
      else if (status === 'loading') {
        this.loading = true;
      }
      else if (status === 'failed') {
        this.loading = false;
        this.loadingFailed = true;
      }
    });

    this.sharedService.appInitialized$.subscribe(async (loaded: boolean) => {
      // if (loaded) {
      //   try {
      //     const p = this.instanceProvider.InstanceProvider;
      //     if (p) {
      //       this.skipChat.Provider = p;
      //       try {
      //         await this.skipChat.Load();
      //         this.loading = false;
      //       }
      //       catch (e) {
      //         this.sharedService.DisplayNotification('Error loading provider to instance', 'error', 2500);
      //       }
      //     }
      //     else {
      //       this.sharedService.DisplayNotification('Error loading provider to instance', 'error', 2500);
      //     } 
      //   } catch (error) {
      //     // Handle any unexpected errors
      //     this.sharedService.DisplayNotification(
      //       'Unexpected error occurred while loading the provider',
      //       'error',
      //       2500
      //     );
      //     console.error('Error:', error);
      //   } finally {
      //     // If needed, trigger change detection at the end of all operations
      //     this.cdr.detectChanges();
      //   }
      // }
    });


    // MJGlobal.Instance.GetEventListener(false).subscribe((event) => {
    //   if (event.event === MJEventType.ComponentEvent) {
    //     if (event.eventCode === 'InstanceChanged') {
    //       this.skipChat.Provider = this.instanceProvider.InstanceProvider;
    //       this.skipChat._initialLoadComplete = false; // temp until we fix this up in the componnet in 2.20.0
    //       this.skipChat.Load(true); 
    //     }
    //   }
    // });
  } 

  public showReport(reportId: string) {
    const prefix = buildRoutePrefix(this.instanceProvider.CurrentInstance.ID);
    this.router.navigate([prefix, 'report', reportId]);
  }
  
  public onConversationSelected(conversationId: string) {
    const prefix = buildRoutePrefix(this.instanceProvider.CurrentInstance.ID);
    this.location.go(`${prefix}/chat/` + conversationId);
  }

  public onNewReportCreated(reportId: string) {
    // tell the report list to refresh itself by sending a message
    MJGlobal.Instance.RaiseEvent({
      event: MJEventType.ComponentEvent,
      eventCode: 'ReportAdded',
      component: this,
      args: { reportId: reportId },
    });
    const prefix = buildRoutePrefix(this.instanceProvider.CurrentInstance.ID);
    this.router.navigate([prefix, 'report', reportId]);
  }
}
